import { MANUAL_ROUTES } from '@/components/OperationsManual/manualCopy';

const NOT_FOUND_STATUS = 404;
const READING_BODY_CLASS = 'om-reading';

export const LOAD_STATES = {
  loading: 'loading',
  ready: 'ready',
  missing: 'missing',
  failed: 'failed',
};

export default {
  data() {
    return { state: LOAD_STATES.loading, states: LOAD_STATES };
  },
  computed: {
    manualKey() {
      return this.$route.params.manualKey || this.$store.getters['operationsManual/firstManualKey'];
    },
  },
  watch: {
    '$route.params': 'load',
  },
  created() {
    this.load();
  },
  mounted() {
    document.body.classList.add(READING_BODY_CLASS);
  },
  beforeDestroy() {
    document.body.classList.remove(READING_BODY_CLASS);
  },
  methods: {
    async load() {
      this.state = LOAD_STATES.loading;
      if (!this.$route.params.manualKey) {
        if (!(await this.redirectToFirstManual())) this.state = LOAD_STATES.missing;
        return;
      }
      try {
        this.state = (await this.fetchContent()) ? LOAD_STATES.ready : LOAD_STATES.missing;
      } catch (error) {
        this.state = error.response && error.response.status === NOT_FOUND_STATUS ? LOAD_STATES.missing : LOAD_STATES.failed;
      }
    },
    async redirectToFirstManual() {
      if (!this.$store.state.operationsManual.isLoaded) {
        await this.$store.dispatch('operationsManual/fetchManuals');
      }
      const manualKey = this.$store.getters['operationsManual/firstManualKey'];
      if (manualKey) this.$router.replace({ name: MANUAL_ROUTES.home, params: { manualKey } });
      return Boolean(manualKey);
    },
  },
};
